'use client';

export default function Footer() {
  return (
    <footer className="w-full bg-[#02020c] py-12 lg:py-20">
      <div className="w-full max-w-7xl mx-auto px-4">
        <div className="flex flex-col gap-12 lg:gap-16 justify-start items-center w-full">
          {/* Main Footer Content */}
          <div className="flex flex-col lg:flex-row items-start justify-between w-full gap-12">
            {/* Company Info */}
            <div className="flex flex-col gap-6 justify-start items-start w-full lg:w-5/12">
              <img
                src="/images/img_group_1707478726.svg"
                alt="Evolutta Logo"
                className="w-[24px] h-[16px] sm:w-[36px] sm:h-[24px] lg:w-[48px] lg:h-[32px]"
              />
              <p 
                className="text-[10px] sm:text-[15px] lg:text-[20px] font-normal leading-[10px] sm:leading-[14px] lg:leading-[19px] text-left text-[#ffffff] w-[54%]"
                style={{ fontFamily: 'Raleway' }}
              >
                Nós seremos a última agência de IA que você irá contratar.
              </p>
            </div>

            {/* Navigation Links */}
            <div className="flex flex-col justify-start items-start self-start w-full lg:w-auto lg:items-center lg:self-center">
              <h4 
                className="text-lg lg:text-2xl font-semibold leading-tight text-left text-[#ffffff]"
                style={{ fontFamily: 'Raleway' }}
              >
                Sitemap
              </h4>
              <div className="flex flex-col justify-start items-start w-full mt-4">
              
                <a 
                  href="#problems"
                  className="text-[10px] sm:text-[15px] lg:text-[20px] font-extralight leading-[12px] sm:leading-[18px] lg:leading-[24px] text-left text-[#ffffff] hover:text-[#b7c3d7] transition-colors duration-200 cursor-pointer"
                  style={{ fontFamily: 'Raleway' }}
                >
                  Problemas
                </a>
                <a 
                  href="#solutions"
                  className="text-[10px] sm:text-[15px] lg:text-[20px] font-extralight leading-[12px] sm:leading-[18px] lg:leading-[24px] text-left text-[#ffffff] hover:text-[#b7c3d7] transition-colors duration-200 cursor-pointer"
                  style={{ fontFamily: 'Raleway' }}
                >
                  Benefícios
                </a>
                <a 
                  href="#dashboard"
                  className="text-[10px] sm:text-[15px] lg:text-[20px] font-extralight leading-[12px] sm:leading-[18px] lg:leading-[24px] text-left text-[#ffffff] hover:text-[#b7c3d7] transition-colors duration-200 cursor-pointer"
                  style={{ fontFamily: 'Raleway' }}
                >
                  Dashboard
                </a>
                <a 
                  href="#method"
                  className="text-[10px] sm:text-[15px] lg:text-[20px] font-extralight leading-[12px] sm:leading-[18px] lg:leading-[24px] text-left text-[#ffffff] hover:text-[#b7c3d7] transition-colors duration-200 whitespace-nowrap cursor-pointer"
                  style={{ fontFamily: 'Raleway' }}
                >
                  Método D.P.E
                </a>
                   <a 
                  href="#specialist"
                  className="text-[10px] sm:text-[15px] lg:text-[20px] font-extralight leading-[12px] sm:leading-[18px] lg:leading-[24px] text-left text-[#ffffff] hover:text-[#b7c3d7] transition-colors duration-200 cursor-pointer"
                  style={{ fontFamily: 'Raleway' }}
                >
                  Especialista
                </a>
                  <a 
                  href="#testimonials"
                  className="text-[10px] sm:text-[15px] lg:text-[20px] font-extralight leading-[12px] sm:leading-[18px] lg:leading-[24px] text-left text-[#ffffff] hover:text-[#b7c3d7] transition-colors duration-200 cursor-pointer"
                  style={{ fontFamily: 'Raleway' }}
                >
                  Depoimentos
                </a>
                   <a 
                  href="#faq"
                  className="text-[10px] sm:text-[15px] lg:text-[20px] font-extralight leading-[12px] sm:leading-[18px] lg:leading-[24px] text-left text-[#ffffff] hover:text-[#b7c3d7] transition-colors duration-200 cursor-pointer"
                  style={{ fontFamily: 'Raleway' }}
                >
                  FAQ
                </a>
              </div>
            </div>

            {/* Social Media and Contact */}
            <div className="flex justify-between items-start w-full lg:flex-1 gap-[20px] lg:gap-[40px]">
              {/* Social Media */}
              <div className="hidden flex flex-col gap-[2px] sm:gap-[3px] lg:gap-[4px] justify-start items-start self-center w-[40%]">
                <h4 
                  className="text-[12px] sm:text-[18px] lg:text-[24px] font-semibold leading-[15px] sm:leading-[22px] lg:leading-[29px] text-left text-[#ffffff]"
                  style={{ fontFamily: 'Raleway' }}
                >
                  Social Media
                </h4>
                <div className="flex flex-col justify-center items-start w-full mt-[8px] sm:mt-[12px] lg:mt-[16px]">
                  <button 
                    className="text-[10px] sm:text-[15px] lg:text-[20px] font-extralight leading-[12px] sm:leading-[18px] lg:leading-[24px] text-left text-[#ffffff] hover:text-[#b7c3d7] transition-colors duration-200"
                    style={{ fontFamily: 'Raleway' }}
                  >
                    Instagram
                  </button>
                  <button 
                    className="text-[10px] sm:text-[15px] lg:text-[20px] font-extralight leading-[12px] sm:leading-[18px] lg:leading-[24px] text-left text-[#ffffff] hover:text-[#b7c3d7] transition-colors duration-200"
                    style={{ fontFamily: 'Raleway' }}
                  >
                    Linkedin
                  </button>
                  <button 
                    className="text-[10px] sm:text-[15px] lg:text-[20px] font-extralight leading-[12px] sm:leading-[18px] lg:leading-[24px] text-left text-[#ffffff] hover:text-[#b7c3d7] transition-colors duration-200"
                    style={{ fontFamily: 'Raleway' }}
                  >
                    Behance
                  </button>
                </div>
              </div>

              {/* Contact Info */}
              <div className="flex flex-col gap-[2px] sm:gap-[3px] lg:gap-[4px] justify-start items-start w-auto">
                <h4 
                  className="text-[12px] sm:text-[18px] lg:text-[24px] font-semibold leading-[15px] sm:leading-[22px] lg:leading-[29px] text-left text-[#ffffff]"
                  style={{ fontFamily: 'Raleway' }}
                >
                  Telefone
                </h4>
                <span 
                  className="text-[10px] sm:text-[15px] lg:text-[20px] font-extralight leading-[12px] sm:leading-[18px] lg:leading-[24px] text-left text-[#ffffff] mt-[8px] sm:mt-[12px] lg:mt-[14px]"
                  style={{ fontFamily: 'Raleway' }}
                >
                  +55 (21) 9 7344-0236
                </span>
              </div>

              {/* CNPJ Info */}
              <div className="flex flex-col gap-[2px] sm:gap-[3px] lg:gap-[4px] justify-start items-start w-auto">
                <h4 
                  className="text-[12px] sm:text-[18px] lg:text-[24px] font-semibold leading-[15px] sm:leading-[22px] lg:leading-[29px] text-left text-[#ffffff]"
                  style={{ fontFamily: 'Raleway' }}
                >
                  CNPJ
                </h4>
                <div className="flex flex-col items-start gap-[6px] sm:gap-[8px] lg:gap-[10px] mt-[8px] sm:mt-[12px] lg:mt-[14px]">
                  <span 
                    className="text-[10px] sm:text-[15px] lg:text-[20px] font-extralight leading-[12px] sm:leading-[18px] lg:leading-[24px] text-left text-[#ffffff]"
                    style={{ fontFamily: 'Raleway' }}
                  >
                    Evolutta: 61.979.875/0001-71
                  </span>
                  <span 
                    className="text-[10px] sm:text-[15px] lg:text-[20px] font-extralight leading-[12px] sm:leading-[18px] lg:leading-[24px] text-left text-[#ffffff]"
                    style={{ fontFamily: 'Raleway' }}
                  >
                    IaSolution: 65.639.848/0001-00
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* Footer Bottom */}
          <div className="flex flex-col sm:flex-row items-center justify-center w-full border-t border-[#ffffff28] pt-[24px] sm:pt-[36px] lg:pt-[48px] pb-[24px] sm:pb-[36px] lg:pb-[48px] pr-[25px] sm:pr-[37px] lg:pr-[50px]">
            <span 
              className="text-[9px] sm:text-[13px] lg:text-[18px] font-normal leading-[11px] sm:leading-[16px] lg:leading-[22px] text-left text-[#ffffff] self-end"
              style={{ fontFamily: 'Raleway' }}
            >
              © 2025 Evolutta. All rights reserved.
            </span>
            <div className="flex justify-end items-center w-full mt-[10px] sm:mt-0">
              <button 
                className="text-[9px] sm:text-[13px] lg:text-[18px] font-normal leading-[11px] sm:leading-[16px] lg:leading-[22px] text-left text-[#ffffff] hover:text-[#b7c3d7] transition-colors duration-200"
                style={{ fontFamily: 'Raleway' }}
              >
                Terms & Conditions
              </button>
              <div className="w-[1px] h-[8px] sm:h-[12px] lg:h-[16px] bg-[#737e93] self-start ml-[12px] sm:ml-[18px] lg:ml-[24px]"></div>
              <button 
                className="text-[9px] sm:text-[13px] lg:text-[18px] font-normal leading-[11px] sm:leading-[16px] lg:leading-[22px] text-left text-[#ffffff] hover:text-[#b7c3d7] transition-colors duration-200 ml-[11px] sm:ml-[16px] lg:ml-[22px]"
                style={{ fontFamily: 'Raleway' }}
              >
                Privacy Policy
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}
